import { useState, useEffect, createContext } from 'react'

const AuthContextExtranet = createContext({})

function useStickyState(defaultValue, key) {
  const [value, setValue] = useState(() => {
    const stickyValue = window.localStorage.getItem(key)
    return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue
  })
  useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])
  return [value, setValue]
}

export const AuthProviderExtranet = ({ children }) => {
  const [auth, setAuth] = useStickyState({}, 'auth')
  return (
    <AuthContextExtranet.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContextExtranet.Provider>
  )
}

export default AuthContextExtranet
